// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"d59845c6","428":"2ee5d306","838":"0256dc14","894":"cfbbd243"}[chunkId] + ".chunk.js";
};